module.exports = __webpack_public_path__ + "static/level-4-card.db85afa1.png";